'use strict'

import React from 'react'
import { View, StyleSheet } from 'react-native'
import FSText from 'app/fs/components/FSText'

import NotificationUnreadIndicator from './NotificationUnreadIndicator'
import NotificationThumbnail from './NotificationThumbnail'
import NotificationTimestamp from './NotificationTimestamp'
import NotificationContent from './NotificationContent'
import styles from './styles'

export default class CommentNotification extends React.Component {
  render() {
    var notif = this.props.notification

    return (
      <View style={styles.notification}>
        <NotificationUnreadIndicator {...this.props} />
        <NotificationThumbnail {...this.props} />

        <NotificationContent {...this.props} iconName="comment-filled">
          <FSText style={styles.bodyText} numberOfLines={3}>
            {notif.comment ? notif.comment.body : ''}
          </FSText>
        </NotificationContent>

        <NotificationTimestamp {...this.props} />
      </View>
    )
  }
}
